import { FIND_RESULT_REQUEST, findResultSuccess, findResultFailure } from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from, EMPTY } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

export function findResultEpic(action$, store$, { ResultRepository }) {
    return action$.pipe(
        ofType(FIND_RESULT_REQUEST),
        mergeMap( action =>{
            const { id } = action.payload;

            if(!`${id}`.trim()) {
                return EMPTY;
            }

            return from(
                ResultRepository.findById( id )
                    .then(result => findResultSuccess(result))
                    .catch(error => findResultFailure(error)),
            );
        }),
    );
}
